import celeMaiVindute from "../data/celeMaiVindute";
import buchete from "../data/buchete";
import bucheteTrandafiri from "../data/bucheteTrandafiri";
import compozitiiCutie from "../data/compozitiiCutie";
import buchetePremium from "../data/buchetePremium";
import paisprezeceFebruarie from "../data/paisprefebruarie";
import optMartie from "../data/optmartie";
import bucheteMireasa from "../data/bucheteMireasa";
import compozitiiDeIarna from "../data/compozitiiDeIarna";
import bucheteIarnaPrimavara from "../data/bucheteIarnaPrimavara";
import bucheteDeVara from "../data/bucheteDeVara";
import bucheteDeToamna from "../data/bucheteDeToamna";

const allFlowers = [
  ...celeMaiVindute,
  ...buchete,
  ...bucheteTrandafiri,
  ...compozitiiCutie,
  ...buchetePremium,
  ...paisprezeceFebruarie,
  ...optMartie,
  ...bucheteMireasa,
  ...compozitiiDeIarna,
  ...bucheteIarnaPrimavara,
  ...bucheteDeVara,
  ...bucheteDeToamna,
];

export const searchFlowers = (query) => {
  if (!query) return allFlowers;

  const lowerCaseQuery = query.toLowerCase();

  // Filter flowers based on the query
  const matchingFlowers = allFlowers.filter(
    (flower) =>
      flower.name.toLowerCase().includes(lowerCaseQuery) ||
      flower.description.toLowerCase().includes(lowerCaseQuery)
  );

  // Create a map to store unique flowers by name
  const uniqueFlowersByName = new Map();

  // For each flower, add it to the map using the name as key
  // This will automatically keep only one entry per flower name
  matchingFlowers.forEach((flower) => {
    // Only add the flower if it doesn't already exist or replace it
    if (!uniqueFlowersByName.has(flower.name)) {
      uniqueFlowersByName.set(flower.name, flower);
    }
  });

  // Convert the map values back to an array
  return Array.from(uniqueFlowersByName.values());
};
